module.exports = __webpack_public_path__ + "static/flexoverlay-271468bae12c1f96c840afe29b087657.png";